export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13517.b2b1b7f9.jpg";